const ORIENTATION = {
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
};

const FONT_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
};

export { ORIENTATION, FONT_COLORS };

export default ORIENTATION;
